<template v-if="addRestrictionMenu.isVisible">
    <div>
        <SwipeModalComponent v-if="addRestrictionMenu.isVisible" @closeMenu="changeAddRestrictionMenuVisibility">
            <div class="content-wrapper">
                <h2>Adicionar Limite de Consumo</h2>

                <div class="school">
                    <h2>Loja</h2>
                    <select class="select" v-model="selectedSchool" v-if="Object.values(getConsumerFamilies).length > 0">
                        <option value="" disabled selected hidden>Selecione uma loja</option>
                        <option
                            class="option"
                            v-for="(store, key) in getConsumerFamilies"
                            :key="key" v-text="store.NMFAMILISALD"
                            :value="store.CDFAMILISALD">
                        </option>
                    </select>
                    <div v-else>
                        <h1>Nenhuma loja encontrada</h1>
                    </div>
                </div>

                <div class="product">
                    <h2>Produto</h2>
                    <div v-if="selectedSchool.length == 0">
                        <h1>Nenhuma loja selecionada</h1>
                    </div>

                    <div v-else-if="getFamilyProducts.length > 0" class="product-selection" @click="changeRestrictionProdModalVisibility">
                        <div class="selected-products">
                            <span v-if="Object.values(selectedProducts).length > 0">
                                {{ selectedProductsString }}
                                <i class="fa fa-magnifying-glass fa-xs"></i>
                            </span>
                            <span v-else>
                                Selecionar produtos
                                <i class="fa fa-magnifying-glass fa-xs"></i>
                            </span>
                        </div>
                    </div>

                    <div v-else-if="loadingProducts">
                        <h1>Carregando produtos</h1>
                    </div>

                    <div v-else>
                        <h1>Nenhum produto encontrado</h1>
                    </div>
                </div>

                <div class="week-days" @click="openModal">
                    <h2>Dias da semana</h2>
                    <!-- mostar lista com dias da semana selecionados, separados por vírgula -->
                    <div class="selected-days" v-if="selectedDays.length > 0">
                        <span>
                            {{ daysString }}
                            <i class="fa fa-magnifying-glass fa-xs"></i>
                        </span>
                    </div>
                    <div v-else>
                        <span>
                            Nenhum dia selecionado
                            <i class="fa fa-magnifying-glass fa-xs"></i>
                        </span>
                    </div>
                </div>

                <div class="proibir">
                    <input type="checkbox" id="cantConsume" v-model="cantConsume" />
                    <label for="cantConsume">Proibir Consumo</label>
                </div>

                <div class="limit" v-if="!cantConsume">
                    <h1>Limite de consumo diário</h1>
                    <div class="edit-limit">
                        <div class="button" @click="decreaseLimit">
                            <i class="fa fa-minus"></i>
                        </div>
                        <input type="text" v-model="limit" />
                        <div class="button" @click="increaseLimit">
                            <i class="fa fa-plus"></i>
                        </div>
                    </div>
                </div>

                <div class="confirmButton" @click="addRestriction">
                    <button>Confirmar</button>
                </div>
            </div>

        </SwipeModalComponent>

        <WeekDaysModalAdd
            label="Dias da Semana"
            :initialDays="selectedDays"
            @closeModal="closeModalA"
            :isOpen="modalAOpen"
        />

        <RestrictionProdModal @closeModal="selectProducts" :products="getFamilyProducts"/>
    </div>

</template>
<script >
import { getFamilyProducts } from '@/components/controllers/FoodRestrictionController'

import SwipeModalComponent from './SwipeModalComponent.vue'
import WeekDaysModalAdd from '@/components/modals/WeekDaysModal.vue'
import RestrictionProdModal from '@/components/modals/RestrictionProdModal.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'AddFoodLimitComponent',
    emits: ['addRestriction'],
    components: {
        SwipeModalComponent,
        WeekDaysModalAdd,
        RestrictionProdModal
    },
    data () {
        return {
            cantConsume: false,
            limit: 0,
            selectedSchool: '',
            familiaSald: '',
            selectedProduct: '',
            selectedProducts: [],
            selectedProductsString: '',
            selectedCDPRODUTO: '',
            selectedDays: [],
            daysString: '',
            modalAOpen: false,
            loadingProducts: false
        }
    },
    computed: {
        ...mapGetters(['addRestrictionMenu', 'weekDaysModal', 'getConsumerFamilies', 'getFamilyProducts'])
    },
    methods: {
        ...mapActions(['changeAddRestrictionMenuVisibility', 'changeRestrictionProdModalVisibility']),
        increaseLimit: function () {
            this.limit++
        },
        decreaseLimit: function () {
            if (this.limit > 0) {
                this.limit--
                if (this.limit === 0) {
                    this.cantConsume = true
                }
            }
        },
        addRestriction: function () {
            if (this.selectedSchool === '' || Object.values(this.selectedProducts).length === 0) {
                alert('Selecione uma escola e um produto')
                return
            }
            const productCodes = this.selectedProducts.map(product => product.CDPRODUTO)

            this.$emit('addRestriction', {
                CDFAMILISALD: this.familiaSald,
                productCodes: productCodes,
                cdWeekDays: this.getWeekDays(),
                QTCONSDIARAL: this.limit
            })
            this.changeAddRestrictionMenuVisibility()
            this.resetData()
        },
        resetData: function () {
            this.limit = 0
            this.cantConsume = false
            this.selectedSchool = ''
            this.selectedProducts = []
            this.selectedProductsString = ''
        },
        openModal () {
            this.modalAOpen = true
        },
        closeModalA (days) {
            this.selectedDays = days
            this.modalAOpen = false
        },
        selectProducts (selectedProducts) {
            this.selectedProducts = selectedProducts
            this.selectedProductsString = selectedProducts.map(product => product.NMPRODUTO).join(', ')
        },
        getWeekDays () {
            // retorna os dias selecionados na forma SSSSSSS (S = selected, N = not selected), começando por domingo
            // ex: ['segunda', 'quarta', 'sexta'] => 'NSNSNSN'
            const weekDays = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
            let weekDaysString = ''
            for (let i = 0; i < weekDays.length; i++) {
                if (this.selectedDays.includes(weekDays[i])) {
                    weekDaysString += 'S'
                } else {
                    weekDaysString += 'N'
                }
            }

            if (weekDaysString === '') {
                weekDaysString = 'NNNNNNN'
            }

            return weekDaysString
        }
    },
    watch: {
        selectedDays (val) {
            if (val.length === 0) {
                this.daysString = 'Nenhum dia selecionado'
                return false
            }
            this.daysString = val.join(', ')
        },
        selectedSchool (val) {
            this.familiaSald = val
            this.loadingProducts = true
            getFamilyProducts(val).then((res) => {
                this.loadingProducts = false
                this.selectedProducts = []
                this.selectedProductsString = ''
            })
        },
        selectedProduct (val) {
            this.selectedCDPRODUTO = val
        }
    }
}
</script>

<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;
    h2 {
        text-align: center;
        margin-bottom: 40px;
    }

    .school, .product {
        margin-bottom: 20px;
        h2 {
            margin-bottom: 10px;
            text-align: left;
        }

        h1 {
            font-style: italic;
        }
        .select {
            width: 100%;
            height: 30px;
            border: solid #BAB8B8 2px;
            border-radius: 5px;
            padding: 0 10px;
            font-size: 18px;
            font-family: Gellix;
            &:focus {
                outline: none;
            }

            option {
                font-size: 14px;
            }
        }
    }

    .product .product-selection, .week-days {
        span {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
    .week-days, .product-selection {
            margin-bottom: 30px;
            h2 {
                margin-bottom: 10px;
                text-align: left;
            }

            div {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;

                span {
                    border: solid #BAB8B8 2px;
                    border-radius: 5px;
                    padding: 5px 10px;
                    width: 100%;
                }
            }
        }

    .proibir {
        border-bottom: solid #BAB8B8 2px;
        padding-bottom: 20px;
        padding-top: 20px;

        input {
          accent-color: var(--buttonBackground);
        }
    }

    // h1 na esquerda e os botões e o limite na direita
    .limit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0;
        padding-bottom: 20px;
        border-bottom: solid var(--cardBorder) 2px;

        h1 {
            // 2 linhas
            max-width: 50%;
        }
        .edit-limit {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100px;
            .button {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background: var(--iconColor);
                display: flex;
                justify-content: center;
                align-items: center;
                i {
                    color: var(--buttonText);
                }
            }

            input {
                margin: 0 5px;
                background-color: var(--backgroundColor);
                color: var(--textColor);
                width: 30px;
                height: 30px;
                border: none;
                font-size: 18px;
                font-family: Gellix;
                text-align: center;
            }
        }
    }

    .confirmButton {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;
    }

    button {
        text-align: right;
        border-radius: 5px;
        color: var(--buttonText);
        padding: 10px;
        margin: 0;
        font-weight: 600;
        border: none;
        background-color: var(--buttonBackground);
    }
}
</style>
